import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@material-ui/core";
import useCustomState from "../../hooks/State";
import Call from "../../service/API";
import Swal from "sweetalert2";
import { ERROR_COLOR, GREEN_PRIMRY, WHITE } from "../../utils/const";

const OrderSelect = ({ orderTypes, update, info }) => {
  const selectedOrderType = useCustomState("");
  return (
    <>
      <FormControl style={{ maxWidth: "30%" }} fullWidth>
        <InputLabel id="select-order-label">انتخاب دستور</InputLabel>
        <Select
          labelId="select-order-label"
          id="select-order"
          value={selectedOrderType.value}
          label="انتخاب دستور"
          onChange={(e) => selectedOrderType.handleChange(e.target.value)}
        >
          {orderTypes.map((type) => (
            <MenuItem key={type.order_type_code} value={type.order_type_id}>
              <em>{type.order_type_name}</em>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Button
        variant="contained"
        color="primary"
        onClick={() =>
          createOrder(selectedOrderType, info.water_meter_serial, update)
        }
      >
        ارسال دستور
      </Button>
    </>
  );
};
export default OrderSelect;
const createOrder = (orderTypeState, deviceSerial, update) => {
  const data = {
    order_type_id: orderTypeState.value,
    water_meter_serial: deviceSerial,
    order_information: {},
  };
  Call("POST", "Order/admin/create", data)
    .then((response) => {
      if (response.data.code === 200) {
        Swal.fire({
          toast: true,
          title: "دستور با موفقیت ارسال شد",
          color: WHITE,
          timer: 4000,
          position: "bottom-start",
          icon: "success",
          showConfirmButton: false,
          timerProgressBar: true,
          background: GREEN_PRIMRY,
        });
        orderTypeState.handleChange("");
        update();
      }
    })
    .catch((error) => {
      if (error.response) {
        Swal.fire({
          toast: true,
          title: "در ارسال دستور خطایی رخ داده",
          color: WHITE,
          timer: 4000,
          position: "bottom-start",
          icon: "error",
          showConfirmButton: false,
          timerProgressBar: true,
          background: ERROR_COLOR,
        });
      }
    });
};
